import type { ReactNode } from 'react';

import type { ActionButton } from '../PageHeader/types';

export type ProcessDialogContentVariant =
  | 'verySpacious'
  | 'spacious'
  | 'default'
  | 'comfortable'
  | 'compact'
  | 'veryCompact'
  | 'fullLength'
  | 'none';

export const PROCESS_DIALOG_CONTENT_PADDING: Record<
  ProcessDialogContentVariant,
  string
> = {
  verySpacious: '80px 120px',
  spacious: '48px 64px',
  default: '32px 48px',
  comfortable: '24px 32px',
  compact: '16px 24px',
  veryCompact: '8px 16px',
  fullLength: '24px 0px',
  none: '0px',
};

export interface ProcessDialogAction {
  label: string;
  onClick: () => void;
  variant?: 'contained' | 'outlined' | 'text';
  color?:
    | 'primary'
    | 'secondary'
    | 'error'
    | 'success'
    | 'warning'
    | 'info'
    | 'inherit';
  disabled?: boolean;
}

export interface ProcessDialogTab {
  label: string;
  content: ReactNode;
  disabled?: boolean;
}

export interface ProcessDialogWithTabsHeaderProps {
  open: boolean;
  onClose: () => void;
  title: ReactNode;
  status?: string | null;
  tabs: ProcessDialogTab[];
  initialIndex?: number;
  headerActions?: ActionButton[];
  contentVariant?: ProcessDialogContentVariant;
  contentPadding?: number | string;
}
